import React, { useState } from 'react';
import { Flex, Text } from '@chakra-ui/core';

import { colors } from '@styles/theme-chakra';
import Link from '../Navigation/Link';
import RightChevron from '../../assets/rightChevron';

const TextLink = ({
  onClick,
  large = false,
  text,
  variant,
  style: propsStyle = {},
  disabled = false,
  to,
  noNewTab = false,
  ...props
}) => {
  const [chevron, setChevron] = useState(false);

  let primaryColors = chevron ? colors.shared : colors.greenPea;
  let secondaryColors = chevron ? colors.shared : colors.white;

  let style = {
    height: '4rem',
    textDecoration: chevron ? 'underline' : null,
    color: primaryColors,
    align: 'left'
  };

  if (variant === 'primary') {
    style = { ...style };
  } else if (variant === 'secondary') {
    style = {
      ...style,
      color: secondaryColors
    };
  }

  return (
    <Link noNewTab={noNewTab} to={to}>
      <Flex
        onMouseEnter={() => {
          setChevron(true);
        }}
        onMouseLeave={() => {
          setChevron(false);
        }}
        align="center"
        direction="row"
      >
        <Text
          pb={6}
          mr={-6}
          as="button"
          onClick={onClick}
          fontWeight="semibold"
          style={{ ...style, ...propsStyle }}
          {...props}
        >
          {text}
        </Text>
        <RightChevron
          pb={6}
          pl={6}
          height={chevron ? 24 : 22}
          width={chevron ? 36 : 22}
          fill={variant === 'primary' ? primaryColors : secondaryColors}
        />
      </Flex>
    </Link>
  );
};

export default TextLink;
